// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__nQDPy","mainContent":"DashboardLayout_mainContent__L8BeL","content":"DashboardLayout_content__RSir4"};